import React, { useState, useRef } from "react";
import { Container, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Button, FormGroup, Modal } from "react-bootstrap";
import { Breadcrumb, ImageElement, LoginHeader } from "../../components";
import { Link } from "react-router-dom";
import { Form, Input } from "antd";
function RequestViewDetails() {
  const target = useRef(null);
  const breadcrumb = [
    {
      path: "/dashboard",
      name: "Home",
    },
    {
      path: "#",
      name: "Request / View Details",
    },
  ];
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { TextArea } = Input;
  return (
    <>
      <LoginHeader />
      <div className="main-content ratingPage requestviewdetails">
        {/* page content */}
        <div className="pageContent">
          <div className="pageContent_wide">
            <Container className="container-lg">
              <div className="d-flex justify-content-between">
                <Breadcrumb title="Request Details" breadcrumb={breadcrumb} />
                <Link
                  to="/my-bookings"
                  className="btn btn-outline-info ms-3 mb-3 btn-sm"
                >
                  Back
                </Link>
              </div>
              <div className="ratingPage_Box br-10 p-30 bg-white">
                <div className="ratingPage_profile mb-4">
                  <div className="ratingPage_profile_content text-center">
                    <ImageElement
                      source="view-details.png"
                      alt="view-details"
                    />
                    <h2 className="mb-0">Steven S. Hurd</h2>
                    <ul className="list-unstyled d-flex starRating mb-0 justify-content-center">
                      <li>
                        <em className="info_icon info_icon-gray gg-full-star active" />
                      </li>
                      <li>
                        <em className="info_icon info_icon-gray gg-full-star active" />
                      </li>
                      <li>
                        <em className="info_icon info_icon-gray gg-full-star active" />
                      </li>
                      <li>
                        <em className="info_icon info_icon-gray gg-full-star active" />
                      </li>
                      <li>
                        <em className="info_icon info_icon-gray gg-full-star active" />
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="ratingPage_Payment">
                  <div className="ratingPage_Services pt-0">
                    <div className="ratingPage_Services_maintenance">
                      <h5 className="ratingsubhead mb-2"> Services Details</h5>
                      <p className="ratingpara mb-0">QA & Category</p>
                      <div className="ratingPage_Services_inner d-flex justify-content-between ">
                        <h5 className="ratingsubhead mb-0">
                          Subcategory Quote Yes Sch
                        </h5>
                        <h5 className="ratingsubhead mb-0">X1</h5>
                      </div>
                      <div className="ratingPage_Services_inner d-flex justify-content-between ">
                        <h5 className="ratingsubhead mb-0 ratingPage_desc">
                          Promo Code Discount
                        </h5>
                        <p className="ratingamount mb-0 ratingPage_amount">
                          $200.00
                        </p>
                      </div>
                      <div className="ratingPage_Services_inner d-flex justify-content-between ">
                        <div className="d-flex align-items-sm-center">
                          <ImageElement
                            source="water-heater.png"
                            className="me-2"
                            alt="water-heater"
                          />
                          <div className="ratingPage_desc">
                            <h5 className="ratingsubhead mb-1 d-flex align-items-center">
                              Apple
                              <OverlayTrigger
                                key="top"
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-top">
                                    Lorem ipsum dolor sit amet.
                                  </Tooltip>
                                }
                              >
                                <Link to="#" ref={target}>
                                  <em className="gg-danger-circle ms-2 text-750" />
                                </Link>
                              </OverlayTrigger>
                            </h5>
                            <p className="ratingamount mb-0 d-flex align-items-center">
                              Monthly Payment
                              <OverlayTrigger
                                key="top"
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-top">
                                    Lorem ipsum dolor sit amet.
                                  </Tooltip>
                                }
                              >
                                <Link to="#" ref={target}>
                                  <em className="gg-danger-circle ms-2 text-750" />
                                </Link>
                              </OverlayTrigger>
                            </p>
                          </div>
                        </div>
                        <div className="ratingPage_amount">
                          <p className="ratingamount mb-1">$200.00</p>
                          <p className="ratingamount mb-0">$100.00</p>
                        </div>
                      </div>
                      <div className="ratingPage_Services_inner d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          <ImageElement
                            source="default-img.png"
                            className="me-2"
                            alt="water-heater"
                          />
                          <div>
                            <h5 className="ratingsubhead mb-0 d-flex align-items-center">
                              Pipe Caliper
                              <OverlayTrigger
                                key="top"
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-top">
                                    Lorem ipsum dolor sit amet.
                                  </Tooltip>
                                }
                              >
                                <Link to="#" ref={target}>
                                  <em className="gg-danger-circle ms-2 text-750" />
                                </Link>
                              </OverlayTrigger>
                            </h5>
                          </div>
                        </div>
                        <div>
                          <p className="ratingamount mb-0">+$25.00</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="ratingPage_Services border-bottom-0">
                    <div className="ratingPage_Services_inner d-flex justify-content-between align-items-center mt-0">
                      <h5 className="ratingsubhead mb-0">Sub Total</h5>
                      <p className="ratingsubhead mb-0">$300.00</p>
                    </div>
                    <div className="ratingPage_Services_inner d-flex justify-content-between align-items-center my-2 ">
                      <h5 className="ratingsubhead mb-0">Total</h5>
                      <p className="ratingsubhead mb-0">$300.00</p>
                    </div>
                    <div className="ratingPage_Services_inner d-flex justify-content-between align-items-center mt-0">
                      <h5 className="ratingsubhead mb-0 d-flex align-items-center">
                        Monthly Payment
                        <OverlayTrigger
                          key="top"
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-top">
                              Lorem ipsum dolor sit amet.
                            </Tooltip>
                          }
                        >
                          <Link to="#" ref={target}>
                            <em className="gg-danger-circle ms-2 text-750" />
                          </Link>
                        </OverlayTrigger>
                      </h5>
                      <p className="ratingsubhead mb-0">$100.00</p>
                    </div>
                  </div>
                  <div className="ratingPage_Services_image">
                    <ImageElement source="customer-img.png" alt="user" />
                  </div>
                  <p className="ratingamount text-center">
                    {" "}
                    Please Sign Here For Estimation Approval
                  </p>
                  <h4 className="ratingheading"> Please Note :</h4>
                  <div className="note">
                    <p>
                      {" "}
                      Payment Is Collected Only After Work Is Done. For Easier
                      Payment Processing Please Add Mastercard, Visa, Discover
                      Or American Express Card. You Will Not Be Charged Until
                      Work Is Completed{" "}
                    </p>
                  </div>
                  <p className="quote text-center">
                    Quote Expire : <span> 30 Days</span>
                  </p>
                </div>
                <div className="d-flex justify-content-end mt-sm-4 mt-3">
                  <button
                    type="button"
                    className="font-sm btn btn-info me-2 min-170 btn-lg"
                    onClick={handleShow}
                  >
                    DECLINE
                  </button>
                  <button
                    type="button"
                    className="font-sm btn btn-primary min-170 btn-lg"
                  >
                    Next
                  </button>
                </div>
                {/* <div className="d-flex justify-content-end mt-sm-4 mt-3">
                                        <button type="button" className="font-sm btn btn-info me-2 min-170 btn-lg">PRINT</button>
                                        <button type="button" className="font-sm btn btn-primary min-170 btn-lg">APPROVED</button>
                                    </div> */}
              </div>
            </Container>
          </div>
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        centered
        id="cancelBooking"
        className="cancelBooking"
        backdrop="static"
      >
        <Modal.Header closeButton className="align-items-start">
          <div>
            <Modal.Title className="text-uppercase">
              DECLINE BOOKING
            </Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form className="cancelBooking_textarea">
            <FormGroup className="form-group">
              <label className="ant-label">Reason</label>
              <TextArea
                rows={8}
                placeholder=""
                maxLength={8}
                value=""
              ></TextArea>
            </FormGroup>
            <div className="d-flex align-items justify-content-end flex-wrap mt-lg-4 mt-2">
              <Button
                variant="light"
                className="min-200 me-3"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                className="min-200"
                onClick={handleClose}
              >
                Continue
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default RequestViewDetails;
